import React, { useEffect, useState } from 'react';
import { XIcon, CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'Giulia',
  city: 'Milano'
}, {
  name: 'Francesca',
  city: 'Roma'
}, {
  name: 'Alessandra',
  city: 'Napoli'
}, {
  name: 'Chiara',
  city: 'Torino'
}, {
  name: 'Elena',
  city: 'Bologna'
}, {
  name: 'Silvia',
  city: 'Firenze'
}, {
  name: 'Martina',
  city: 'Palermo'
}, {
  name: 'Giovanna',
  city: 'Genova'
}, {
  name: 'Laura',
  city: 'Bari'
}, {
  name: 'Valentina',
  city: 'Verona'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 10000 + 15000);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed top-4 right-4 z-50 max-w-[280px]" data-id="element-182">
      <div className="bg-white border-2 border-brand-primary rounded-lg p-3 shadow-xl relative" data-id="element-183">
        <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-brand-muted hover:text-brand-text" aria-label="Chiudi" data-id="element-184">
          <XIcon className="w-4 h-4" data-id="element-185" />
        </button>

        <div className="flex items-center gap-3 pr-4" data-id="element-186">
          <div className="w-10 h-10 rounded-full bg-brand-primary text-white flex items-center justify-center font-heading font-bold text-lg shrink-0" data-id="element-187">
            {currentBuyer.name.charAt(0)}
          </div>
          <div className="min-w-0" data-id="element-188">
            <p className="text-xs text-brand-text leading-tight" data-id="element-189">
              <span className="font-bold" data-id="element-190">{currentBuyer.name}</span> da{' '}
              <span className="font-semibold" data-id="element-191">{currentBuyer.city}</span> ha
              acquistato Tiroide Felice
            </p>
            <div className="flex items-center gap-1 mt-1" data-id="element-192">
              <CheckCircle2Icon className="w-3 h-3 text-green-600" data-id="element-193" />
              <span className="text-[10px] text-green-600 font-bold" data-id="element-194">
                Acquisto verificato
              </span>
              <span className="text-[10px] text-brand-muted" data-id="element-195">
                · {timeAgo} min fa
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}